import React, { useContext, useEffect, useState } from "react";
import useSnackbar from "../../../hooks/useSnackbar";
import { useParams, useSearchParams } from "react-router-dom";
import _ from "lodash";

import {
  Button,
  Divider,
  Grid,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  Typography,
  colors,
  Paper,
  IconButton,
  TextField,
  TablePagination
} from "@mui/material";

import { DateTimePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"; // or any other adapter like AdapterDateFns
import dayjs from "dayjs";

import { useTheme } from "@mui/material/styles";

import SearchIcon from "@mui/icons-material/Search";

import AlertDialog from "../../../components/Dialogs/AlertDialog";

import ContainerLoading from "../../../components/Loading/ContainerLoading";

import { formatDate } from "../../../utils/misc";

import UpdateLogRow from "./ErrorLogs/ErrorLogRow"; //TODO remove
import ActivityLogRow from "./ActivityLogs/ActivityLogRow";
import StatusDropdown from "./ErrorLogs/StatusDropdown";
import EventDropdown from "./ActivityLogs/EventDropdown";

import LocationCodeDropdown from "./Shared/LocationCodeDropdown";

import { KEY_NAME_REGEX } from "../../../constants";

import HttpContext from "../../../contexts/HTTP/HttpContext";

function ActivityLogs() {
  const theme = useTheme();
  const { get, post } = useContext(HttpContext);

  const [loading, setLoading] = useState(true);

  const [allLogs, setAllLogs] = useState([]);

  const { id } = useParams(); // Get the ID from the URL

  const [filterStartDate, setFilterStartDate] = useState(
    dayjs().subtract(2, "month")
  );
  const [filterEndDate, setFilterEndDate] = useState(dayjs());

  const { openSnackbar } = useSnackbar();

  const [searchParams] = useSearchParams();
  const startDate = searchParams.get("startDate");
  const endDate = searchParams.get("endDate");
  const kioskID = searchParams.get("kioskID");
  const event = searchParams.get("event");

  const [filterKioskID, setFilterKioskID] = useState(kioskID);
  const [filterEvent, setFilterEvent] = useState(event);

  const [showPayload, setShowPayload] = useState(false);
  const [payloadString, setPayloadString] = useState("");

  const [paginationTotal, setPaginationTotal] = useState(0);
  const [paginationPage, setPaginationPage] = useState(0);
  const [paginationLimit, setPaginationLimit] = useState(25);
  const [paginationTotalPages, setPaginationTotalPages] = useState(0);

  const refresh_core = async payload => {
    setLoading(true);

    console.log("payload", payload);

    //Load data
    const res2 = await post("/kiosk/getActivityLogs", payload);

    if (res2.status !== 200) {
      openSnackbar({
        open: true,
        message: "Unable to load sync logs",
        variant: "alert",
        alert: {
          color: "error"
        },
        close: false
      });
    }

    if (res2.status == 403 || res2.status == 401) {
      //logout and redirect to login
      await get("/logout");
      localStorage.removeItem("accessToken");
      window.location.href = "/login";
    }

    if (res2.status === 200) {
      const subscriptionData = _.get(res2, "data");

      setAllLogs(subscriptionData.data || []);
      console.log("loadDetails", subscriptionData);

      if (!subscriptionData.metadata) {
        setPaginationTotal(0);
        setPaginationPage(0);
        setPaginationTotalPages(0);
      } else {
        setPaginationTotal(subscriptionData.metadata.total);
        setPaginationPage(subscriptionData.metadata.page);
        setPaginationLimit(subscriptionData.metadata.limit);
        setPaginationTotalPages(subscriptionData.metadata.totalPages);
      }

      //TESTING
      console.log("id via parameter", id);

      if (id !== undefined) {
        console.log("id not null");
      }

      setLoading(false);
    }

    setLoading(false);
  };

  const refresh_table = async (newpage, newlimit) => {
    let payload = {
      kioskID: filterKioskID,
      startDate: filterStartDate.toISOString(),
      endDate: filterEndDate.toISOString(),
      event: filterEvent,
      page: newpage,
      limit: newlimit
    };

    refresh_core(payload);
  };

  const handleChangePage = async (event, newPage) => {
    await setPaginationPage(newPage);
    await refresh_table(newPage, paginationLimit);
  };

  const handleChangeRowsPerPage = async event => {
    const newlimit = parseInt(event.target.value, 10);
    await setPaginationLimit(newlimit);
    await setPaginationPage(0);
    await refresh_table(0, newlimit);
  };

  useEffect(() => {
    // Scroll to the element with the specified ID once the list is loaded
    if (loading === false && id) {
      const targetElement = document.getElementById(id);
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [loading, id]);

  const loadDetails = async id => {};

  const handleActionShowData = async inboundData => {
    setPayloadString(inboundData);
    setShowPayload(true);
  };

  useEffect(() => {
    (async () => {
      await refresh_table(paginationPage, paginationLimit);
    })();
  }, []);

  return (
    <Grid
      style={{
        margin: theme.spacing(2),
        padding: theme.spacing(3),
        width: "100%",
        backgroundColor: colors.grey[100],
        borderRadius: "10px"
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            marginBottom: theme.spacing(2)
          }}
        >
          <Typography variant="h4">Activity Logs</Typography>
          <Typography variant="h5" style={{ marginLeft: theme.spacing(2) }}>
            <span style={{ color: "grey" }}>
              ({paginationTotal} result{paginationTotal.length == 1 ? "" : "s"})
            </span>
          </Typography>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: theme.spacing(2)
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: theme.spacing(1)
          }}
        >
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DateTimePicker
              label="Start Date"
              value={filterStartDate}
              onChange={newValue => {
                console.log("DateTimePicker", newValue);
                setFilterStartDate(newValue);
              }}
            />
            <DateTimePicker
              label="End Date"
              value={filterEndDate}
              onChange={newValue => {
                console.log("DateTimePicker", newValue);
                setFilterEndDate(newValue);
              }}
            />
          </LocalizationProvider>
          <TextField
            id="kis"
            label="KioskID"
            value={filterKioskID}
            onChange={event => {
              let newText = event.target.value;
              newText = newText.trim();
              setFilterKioskID(newText);
            }}
          />
          <EventDropdown
            value={filterEvent}
            onChange={(e, val) => {
              setFilterEvent(val);
            }}
          />
        </div>
        <div>
          <Button
            style={{ marginLeft: "9px" }}
            variant="contained"
            onClick={async () => await refresh_table(0, paginationLimit)}
            disabled={loading}
          >
            <SearchIcon />
            Search
          </Button>
        </div>
      </div>
      <Divider
        style={{ marginBottom: theme.spacing(2), marginTop: theme.spacing(2) }}
      />
      <ContainerLoading show={loading} />
      <TableContainer>
        <Table
          style={{
            marginTop: theme.spacing(2),
            display: loading ? "none" : null
          }}
        >
          <TableHead>
            <TableRow>
              <TableCell>Timestamp</TableCell>
              <TableCell align="left">Kiosk ID</TableCell>
              <TableCell align="left">Event</TableCell>
              <TableCell align="center">Details</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {allLogs.map((row, index) => (
              <ActivityLogRow
                row={row}
                key={index}
                handleActionShowData={handleActionShowData}
              />
            ))}
          </TableBody>
        </Table>
        <TablePagination
          component="div"
          count={paginationTotal}
          page={paginationPage}
          onPageChange={handleChangePage}
          rowsPerPage={paginationLimit}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>

      <AlertDialog
        open={showPayload}
        handleClose={() => {
          setShowPayload(false);
          setPayloadString("");
        }}
        title="Inbound Data"
      >
        {/* <Paper elevation={3} sx={{ p: 2, marginBottom: theme.spacing(2) }}> */}
        <Paper elevation={2} sx={{ p: 2, backgroundColor: "lightgrey" }}>
          <Typography
            variant="body2"
            component="code"
            style={{ wordWrap: "break-word" }}
          >
            {payloadString}
          </Typography>
        </Paper>
      </AlertDialog>
    </Grid>
  );
}

export default ActivityLogs;

function isKeyNameValid(name) {
  if (!name) return false;

  return KEY_NAME_REGEX.test(name);
}

function isKeyNameDuplicate(keys, name) {
  return keys.map(key => key.name).includes(name);
}

function getKeyNameHelperText(keys, name) {
  if (!isKeyNameValid(name)) {
    return "Invalid name";
  }

  if (isKeyNameDuplicate(keys, name)) {
    return "Name already in use";
  }

  return "";
}
